import groq from 'groq'

export const imageFragment = groq`
  ...,
  asset->,
`
